import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Chip, Typography, TextField,
  FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle,
  DialogContent, DialogActions
} from '@mui/material';
import { Add, Edit, Delete, Visibility } from '@mui/icons-material';
import { getPages, deletePage } from '../services/api';

function PagesPage() {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ status: '', search: '' });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, page: null });
  const navigate = useNavigate();

  useEffect(() => {
    loadPages();
  }, [filter.status]);

  const loadPages = async () => {
    try {
      const params = {};
      if (filter.status) params.status = filter.status;
      const { data } = await getPages(params);
      setPages(data);
    } catch (error) {
      console.error('Erreur chargement pages:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      await deletePage(deleteDialog.page._id);
      setDeleteDialog({ open: false, page: null });
      loadPages();
    } catch (error) {
      console.error('Erreur suppression:', error);
    }
  };

  const filteredPages = pages.filter(page =>
    page.title.toLowerCase().includes(filter.search.toLowerCase())
  );

  const statusColors = {
    draft: 'default',
    review: 'warning',
    published: 'success',
    archived: 'error'
  };

  const statusLabels = {
    draft: 'Brouillon',
    review: 'En revue',
    published: 'Publie',
    archived: 'Archive'
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold">
          Pages
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => navigate('/pages/new')}
        >
          Nouvelle page
        </Button>
      </Box>

      <Card sx={{ mb: 3, p: 2 }}>
        <Box display="flex" gap={2}>
          <TextField
            size="small"
            label="Rechercher"
            value={filter.search}
            onChange={(e) => setFilter({ ...filter, search: e.target.value })}
            sx={{ minWidth: 200 }}
          />
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Statut</InputLabel>
            <Select
              value={filter.status}
              label="Statut"
              onChange={(e) => setFilter({ ...filter, status: e.target.value })}
            >
              <MenuItem value="">Tous</MenuItem>
              <MenuItem value="draft">Brouillon</MenuItem>
              <MenuItem value="review">En revue</MenuItem>
              <MenuItem value="published">Publie</MenuItem>
              <MenuItem value="archived">Archive</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Card>

      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Titre</TableCell>
                <TableCell>Slug</TableCell>
                <TableCell>Template</TableCell>
                <TableCell>Statut</TableCell>
                <TableCell>Modifie le</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPages.map((page) => (
                <TableRow key={page._id} hover>
                  <TableCell>
                    <Typography fontWeight="medium">{page.title}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      /{page.slug}
                    </Typography>
                  </TableCell>
                  <TableCell>{page.template}</TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={statusLabels[page.status]}
                      color={statusColors[page.status]}
                    />
                  </TableCell>
                  <TableCell>
                    {new Date(page.updatedAt).toLocaleDateString('fr-FR')}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      onClick={() => window.open(`http://localhost:3010/${page.slug}`, '_blank')}
                    >
                      <Visibility />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => navigate(`/pages/${page._id}`)}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => setDeleteDialog({ open: true, page })}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Dialog open={deleteDialog.open} onClose={() => setDeleteDialog({ open: false, page: null })}>
        <DialogTitle>Confirmer la suppression</DialogTitle>
        <DialogContent>
          Voulez-vous vraiment supprimer la page "{deleteDialog.page?.title}" ?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, page: null })}>
            Annuler
          </Button>
          <Button color="error" variant="contained" onClick={handleDelete}>
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default PagesPage;
